module.exports = __webpack_public_path__ + "static/thumb_hotel-29ef274ec9fafb2caae5554d5c7995a0.jpg";